import React from "react";
import PropTypes from "prop-types";
import {
  Popover,
  Button,
  makeStyles,
  PopoverTrigger,
  PopoverSurface,
  mergeClasses,
  OverlayDrawer,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody
} from "@fluentui/react-components";
import { Dismiss20Regular, Emoji24Filled } from "@fluentui/react-icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useCssBreakpoints } from "react-use-css-breakpoints";

const useStyles = makeStyles({
  emojisPopoverSurface: {
    top: "-15px!important",
    padding: "8px"
  },
  emojisPopover: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap"
  },
  emoji: {
    fontSize: "20px"
  },
  emojiButton: {
    padding: "6px",
    transition: "transform 0.2s ease-in-out",
    ":hover": {
      transform: "scale(1.15)"
    }
  },
  buttonPressed: {
    backgroundColor: "var(--primaryColorBackground)"
  },
  emojiDrawer: {
    height: "auto"
  }
});

export function ToolbarEmojisButton({ styles, items, open, onOpenChange }) {
  const classes = useStyles();
  const intl = useIntl();
  const handleOpenChange = (_, data) => {
    onOpenChange(data.open || false);
  };
  const breakpoint = useCssBreakpoints();

  return (
    <>
      {breakpoint !== "sm" && breakpoint !== "md" && (
        <div position="center">
          <Popover className={styles.emojiPopover} open={open} onOpenChange={handleOpenChange}>
            <PopoverTrigger>
              <Button
                appearance="subtle"
                className={open ? mergeClasses(styles.button, classes.buttonPressed) : styles.button}
                icon={<Emoji24Filled />}
              />
            </PopoverTrigger>
            <PopoverSurface className={classes.emojisPopoverSurface}>
              <div className={classes.emojisPopover}>
                {items.map(item => (
                  <Button
                    className={classes.emojiButton}
                    key={item.id}
                    appearance="transparent"
                    icon={item.icon}
                    onClick={() => {
                      item.onSelect(item);
                    }}
                  />
                ))}
              </div>
            </PopoverSurface>
          </Popover>
        </div>
      )}
      {(breakpoint === "sm" || breakpoint === "md") && (
        <>
          <OverlayDrawer
            open={open}
            onOpenChange={handleOpenChange}
            position="bottom"
            modalType="non-modal"
            className={classes.emojiDrawer}
          >
            <DrawerHeader>
              <DrawerHeaderTitle
                action={
                  <Button
                    appearance="subtle"
                    aria-label={intl.formatMessage({
                      id: "room-settings-sidebar.close-button",
                      defaultMessage: "Close"
                    })}
                    icon={<Dismiss20Regular />}
                    onClick={e => handleOpenChange(e, { open: false })}
                  />
                }
              >
                <FormattedMessage id="reaction-popover.title" defaultMessage="Emotes" />
              </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
              <div className={classes.emojisPopover}>
                {items.map(item => (
                  <Button
                    className={classes.emojiButton}
                    key={item.id}
                    appearance="transparent"
                    icon={item.icon}
                    onClick={() => {
                      item.onSelect(item);
                    }}
                  />
                ))}
              </div>
            </DrawerBody>
          </OverlayDrawer>
        </>
      )}
    </>
  );
}

ToolbarEmojisButton.propTypes = {
  styles: PropTypes.object,
  scene: PropTypes.object,
  hubChannel: PropTypes.object,
  items: PropTypes.array.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func
};
